<template lang="html">
  <div class="container">
    <div class="row1">
      <img class="bbc" src="@/assets/img/logos/crsWhiteLogos/BBC.png" alt="BBC logo" />
      <img class="washington" src="@/assets/img/logos/crsWhiteLogos/Washington.png" alt="Washington Post logo" />
      <img class="guardian hide-for-small-only" src="@/assets/img/logos/crsWhiteLogos/Guardian.png" alt="Guardian Logo" />
    </div>

    <div class="row2">
      <img class="guardian show-for-small-only" src="@/assets/img/logos/crsWhiteLogos/Guardian.png"  alt="Guardian Logo" />
      <img class="ft" src="@/assets/img/logos/crsWhiteLogos/FT.png" alt="Financial Times logo" />
      <img class="times hide-for-small-only" src="@/assets/img/logos/crsWhiteLogos/Times.png" alt="Times logo" />
    </div>

    <div class="row3 show-for-small-only">
      <img class="times" src="@/assets/img/logos/crsWhiteLogos/Times.png" alt="Times logo" />
    </div>

  </div>
</template>

<script>

export default {
  name: 'HomeProductsCrsLogos',
  props: {
  },
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container {
  background-color: $mid-grey-background;
  display: flex;
  flex-direction: row;
  padding: 70px 15% 70px 15%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.logo {
  height: auto;
  width: auto;
}

@media only screen and (max-width: 800px) {
  .container {
    padding: 20px 10% 0 10%;
  }

  .row1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 30px;
  }

  .row2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .row3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
  }

  .bbc {
    width: 90px;
    height: 26px;
  }

  .washington {
    width: 190px;
    height: 27px;
  }

  .guardian {
    width: 90px;
    height: 30px;
  }

  .ft {
    width: 190px;
    height: 15px;
    margin-right: 0;
  }

  .times {
    width: 190px;
    height: 22.5px;
  }
}

@media only screen and (min-width: 800px) {
  .row1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
  }

  .row2 {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bbc {
    width: 180px;
  }

  .washington {
    width: 390px;
    height: auto;
  }

  .guardian {
    width: 180px;
  }

  .ft {
    width: 380px;
    height: 30px;
    margin-right: 120px;
  }

  .times {
    width: 380px;
    height: 45px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCrs/components/homeProductsCrsLogos.vue